import { Anchor, Button, Stack, Text, TextInput, Title } from "@mantine/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { NavBarContainer } from "./NavBarContainer";
import { ApiError, RestApi } from "../shared/RestApi";

export function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = React.useState("");
  const [error, setError] = React.useState<string | null>(null);
  const [done, setDone] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await RestApi.localAuthForgot(email.trim());
      setDone(true);
    } catch (err) {
      const message =
        err instanceof ApiError ? err.message : t("forgotPassword.error");
      setError(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <NavBarContainer>
      <Stack gap="md" maw={480}>
        <Title order={3}>{t("forgotPassword.title")}</Title>
        {done ? (
          <Text>{t("forgotPassword.sent")}</Text>
        ) : (
          <>
            <Text>{t("forgotPassword.intro")}</Text>
            <form onSubmit={onSubmit}>
              <Stack gap="sm">
                <TextInput
                  label={t("forgotPassword.email")}
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.currentTarget.value)}
                />
                {error ? (
                  <Text c="red" size="sm">
                    {error}
                  </Text>
                ) : null}
                <Button type="submit" loading={submitting}>
                  {t("forgotPassword.submit")}
                </Button>
              </Stack>
            </form>
          </>
        )}
        <Anchor component={Link} to="/signin">
          {t("forgotPassword.backToSignIn")}
        </Anchor>
      </Stack>
    </NavBarContainer>
  );
}
